/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef, useState, useEffect } from "react";
import { UserContext } from "../../context/UserContext";
import ContactItem from "./ContactItem";

import { getAuth, signOut } from "firebase/auth";
import copy from "copy-to-clipboard";
import Dialog from "@mui/material/Dialog";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import SearchIcon from "@mui/icons-material/Search";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Menu, MenuItem } from "@mui/material";

import { Box } from "@mui/system";
import { IconButton, Button, Snackbar } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
// import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
// import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import {
  useUsersList,
  useContactList,
  removeUserFromList,
  addUserToList,
} from "../../API/ContactsAPI";

const ContactList = (props) => {
  const userCtx = useContext(UserContext);
  const uidField = useRef();
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [userToBeDeleted, setUserToBeDeleted] = useState({
    chatID: "",
    uid: "",
  });
  const [filterString, setFilterString] = useState("");

  const [contactList, isContactsLoading] = useContactList();
  const [users] = useUsersList();

  //Asking for confirmation before deleting user
  const showConfirmation = (chatID, uid) => {
    setUserToBeDeleted({ chatID, uid });
    setOpenDialog(true);
  };

  const filterOut = (event) => {
    setFilterString(event.target.value);
  };

  //Deleting the selected user
  const deleteSelectedUser = () => {
    let updatedContactList = contactList.data().contactList.filter((user) => {
      return userToBeDeleted.uid !== user.uid;
    });
    removeUserFromList(updatedContactList, userToBeDeleted);
  };

  //Closing all the chats and dialog if the contact list gets updated
  useEffect(() => {
    userCtx.setshowChat(false);
    userCtx.setRemoveIconState(false);
    setOpenDialog(false);
  }, [contactList]);

  const signout = () => {
    if (!isContactsLoading) {
      signOut(getAuth())
        .then(() => {
          userCtx.setSignedIn(false);
        })
        .catch((error) => {});
    } else {
      showError("Wait loading data......");
    }
  };

  const toggleContactRemoveIcon = () => {
    userCtx.setRemoveIconState((prevState) => {
      return prevState === false;
    });
    setAnchorEl(null);
  };

  //checking if user exists
  const doesUserExist = (uid) => {
    return users.docs.some((user) => user.id === uid);
  };

  //checking if user is already added before adding to contact list with uid
  const wasUserAdded = (uid) => {
    if (contactList.data() && !isContactsLoading) {
      return contactList
        .data()
        .contactList.some((contact) => contact.uid === uid);
    }
    return true;
  };

  //checking if user was deleted before from contact list
  const wasUserDeleted = (uid) => {
    if (contactList.data().deleted) {
      return contactList.data().deleted.find((user) => user.uid === uid);
    }
    return false;
  };

  const addUserFromUID = () => {
    const userToBeAdded = uidField.current.value;
    if (
      !addUserToList(
        userToBeAdded,
        doesUserExist(userToBeAdded),
        wasUserAdded(userToBeAdded),
        wasUserDeleted(userToBeAdded)
      )
    ) {
      showError("Invalid User or Already added to contacts");
    }
  };

  const showError = (msg) => {
    setErrorMsg(msg);
    setOpenSnackBar(true);
  };

  const copyUID = () => {
    copy(getAuth().currentUser.uid);
    showError("User ID Copied to Clipboard");
  };

  const hideError = () => {
    setOpenSnackBar(false);
  };

  const cancelAlert = () => {
    userCtx.setRemoveIconState(false);
    setOpenDialog(false);
  };

  //burger button
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const burgerMenuHandler = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const burgerMenuCloseHandler = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Snackbar
        open={openSnackBar}
        onClose={hideError}
        autoHideDuration={3200}
        message={errorMsg}
      />
      <Dialog open={openDialog}>
        <DialogTitle>Do you want to remove this contact ?</DialogTitle>
        <DialogContent>
          You won't be able to talk with this person
        </DialogContent>
        <DialogActions>
          <Button onClick={deleteSelectedUser}>Yes</Button>
          <Button onClick={cancelAlert}>No</Button>
        </DialogActions>
      </Dialog>

      <Menu anchorEl={anchorEl} open={open} onClose={burgerMenuCloseHandler}>
        {/* <MenuItem>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              fontSize: "large",
              alignItems: "center",
              gap: "1.2rem",
              padding: "2% 0",
            }}
          >
            <AccountCircleOutlinedIcon
              sx={{ color: "#707579", fontSize: "1.96rem" }}
            />
            Profile
          </Box>
        </MenuItem> */}
        {/* <MenuItem>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              fontSize: "large",
              alignItems: "center",
              gap: "1.2rem",
              padding: "2% 0",
            }}
          >
            <DarkModeOutlinedIcon
              sx={{ color: "#707579", fontSize: "1.96rem" }}
            />
            Dark Mode
          </Box>
        </MenuItem> */}
        <MenuItem onClick={toggleContactRemoveIcon}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              fontSize: "large",
              alignItems: "center",
              gap: "1.2rem",
              padding: "2% 0",
            }}
          >
            <PersonRemoveOutlinedIcon
              sx={{ color: "#707579", fontSize: "1.96rem" }}
            />
            Remove Contacts
          </Box>
        </MenuItem>
        <MenuItem onClick={signout}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              fontSize: "large",
              alignItems: "center",
              gap: "1.2rem",
              padding: "2% 0",
            }}
          >
            <LogoutIcon sx={{ color: "#707579", fontSize: "1.96rem" }} />
            Log out
          </Box>
        </MenuItem>
      </Menu>

      {/* Contact List Header with Searchbar */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row-reverse",
          flex: "1",
          justifyContent: "flex-end",
          width: "100%",
          backgroundColor: { laptop: "#ededed", mobile: "#b2b1b9" },
          alignItems: "center",
        }}
      >
        {/* <Box
          sx={{ display: "flex", alignItems: "center", marginRight: "0.8rem" }}
        >
          <Tooltip title="Copy UID To Clipboard" arrow>
            <Avatar
              alt="user-icon"
              onClick={copyUID}
              sx={{
                background: "white",
                padding: "4%",
                border: "1px solid #1976D2",
              }}
              src={`https://avatars.dicebear.com/api/bottts/${
                getAuth().currentUser.uid
              }.svg`}
            />
          </Tooltip>
        </Box> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: { laptop: "70%", mobile: "75%" },
            alignItems: "center",
            padding: { laptop: "1.2%", mobile: "1%" },
            margin: { mobile: "0.5rem 0", laptop: "0" },
            gap: "0.2rem",
            borderRadius: "18px",
            background: "white",
          }}
        >
          <SearchIcon sx={{ color: "#808080" }} />
          <input
            type="text"
            placeholder="Search"
            onChange={filterOut}
            style={{
              width: "85%",
              height: "1.75rem",
              boxShadow: "none",
              borderColor: "white",
              border: "0",
              padding: "0.6%",
              fontSize: "medium",
              outline: "none",
              overflowY: "scroll",
              background: "white",
            }}
          />
        </Box>

        <Button
          variant="contained"
          sx={{
            marginRight: "0.4rem !important",
            color: "black",
            background: "transparent",
            boxShadow: "none",
            ":hover": {
              background: "transparent",
              boxShadow: "none",
              color: "blue",
            },
          }}
          onClick={burgerMenuHandler}
        >
          <MenuIcon />
        </Button>
      </Box>

      {/* Contact List main body */}
      <Box
        sx={{
          width: "100%",
          flex: "12",
          alignItems: "center",
          overflowY: "scroll",
          borderBottom: "0px",
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {!isContactsLoading &&
          contactList.data() &&
          contactList
            .data()
            .contactList.map((user, index) => (
              <ContactItem
                uid={user.uid}
                chatId={user.chatID}
                key={user.chatID}
                filterString={filterString}
                remove={showConfirmation}
                index={index}
              />
            ))}
        <Box
          sx={{
            color: "#808080",
            fontSize: "13px",
            cursor: "pointer",
            fontWeight: "600",
            display: "flex",
            justifyContent: "center",
            marginTop: "0.5rem",
            // borderBottom: "1.5px solid",
          }}
          onClick={copyUID}
        >
          Click here to copy ur User ID 👆
        </Box>
      </Box>

      {/* Add user input field */}
      <Box
        sx={{
          backgroundColor: "transparent",
          display: "flex",
          flex: "1",
          flexDirection: "row",
          height: "auto",
          justifyContent: "space-evenly",
          alignItems: "center",
          padding: "1% 1.5%",
          marginBottom: "0.5em",
        }}
      >
        <input
          type="text"
          placeholder="Add User with ID"
          ref={uidField}
          style={{
            height: "2.5rem",
            width: "80%",
            borderRadius: "10px",
            fontSize: "medium",
            border: "0",
            outline: "none",
            boxShadow: "0px 0.5px 2.5px rgba(0, 0, 0, 0.50)",
            padding: "2%",
          }}
        />
        <IconButton
          aria-label="back"
          size="large"
          onClick={addUserFromUID}
          backgroundColor
          sx={{
            boxShadow: "0px 0.5px 2.5px rgba(0, 0, 0, 0.40)",
            color: "white",
            backgroundColor: "#1976D2",
            ":hover": {
              background: "white",
              color: "#1976D2",
            },
          }}
        >
          <PersonAddAltIcon sx={{ color: "inherit" }} />
        </IconButton>
      </Box>
    </>
  );
};

export default ContactList;
